import routerOptions0 from "/builds/s-o-f/vkusilosos-frontend/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/builds/s-o-f/vkusilosos-frontend/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}